import queryStringParameters, { parseQueryString } from './queryStringParameters';
import * as actions from '../constants/actions';

const queryStringMiddleware = queryStringParameters => store => next => action => {
	if (action.type === actions.APP_INIT) {
		const params = action.payload && action.payload.params ?
			{
				...action.payload.params,
				...queryStringParameters
			} : queryStringParameters;
		const payload = {
			...action.payload,
			params
		};
		return next({
			...action,
			payload
		});
	} else if (action.type === actions.FORM_INIT && queryStringParameters.sitecode) {
		const payload = {
			...action.payload,
			sitecode: queryStringParameters.sitecode
		};
		return next({
			...action,
			payload
		});
	} else if (action.type === actions.SSO_AUTHENTICATION_COMPLETE) {

		// Nothing to do here if browser doesn't support history.replaceState
		if (!window.history || !window.history.replaceState) {
			return next(action);
		}

		// Clean up our URL by removing SSO-specific query string parameters
		let params = {
			...queryStringParameters
		};
		delete params.responseDetails;
		delete params.signature;
		delete params.role;
		delete params.enablehttps;

		const queryParams = Object.keys(params).map(key => {
			const value = params[key];
			if (!value && value !== false) {
				return encodeURIComponent(key);
			}
			return `${ encodeURIComponent(key) }=${ encodeURIComponent(value) }`;
		});
		const queryString = queryParams.length ? `?${ queryParams.join('&') }` : '';
		const url = (window.location.pathname || '/') + queryString;
		if (window.history && window.history.replaceState) {
			window.history.replaceState(null, 'Imagine Learning', url);
		}
	} else if (action.type === actions.APP_APPLY_STORED_QUERY_PARAMS){
		// Parse our previous query parameters.
		if(!action.payload || !action.payload.prevQueryParams){
			return;
		}
		
		let prevQueryParams = action.payload.prevQueryParams;
		let prevQueryParamsList = parseQueryString(prevQueryParams);

		// If there are any duplicate parameters, let's strip them out here.
		// We assume that the current parameters' values supercede the old ones.
		let existingParams = Object.keys(queryStringParameters);
		existingParams.forEach(element => {
			if(prevQueryParamsList[element.toString()] != null){
				delete prevQueryParamsList[element.toString()];
			}
		});

		// Combine the parameters into one object.
		let params = {
			...queryStringParameters,
			...prevQueryParamsList
		};

		// Create an appropriate string that has encoded everything.
		const queryParams = Object.keys(params).map(key => {
			const value = params[key];
			if (!value && value !== false) {
				return encodeURIComponent(key);
			}
			return `${ encodeURIComponent(key) }=${ encodeURIComponent(value) }`;
		});

		const queryString = queryParams.length ? `?${ queryParams.join('&') }` : '';
		const url = (window.location.pathname || '/') + queryString;

		// Replace the URL to use the new query parameters.
		if(window.history && window.history.replaceState){
			window.history.replaceState(null, 'Imagine Learning', url);
		}
	}
	return next(action);
};

export default queryStringMiddleware(queryStringParameters);



// WEBPACK FOOTER //
// ./src/services/queryStringMiddleware.js